// @flow

import { MunicipalitySearch } from './component'
import type { municipalitySearchProps } from './component'
import { connect } from 'react-redux'
import type { FilterType } from './reducer'
import { lookupString } from './reducer'

type remoteDataType = {
  filter: FilterType
}

function mapStateToProps ({ filter }: remoteDataType): municipalitySearchProps {
  return {
    lookupString: filter.lookupString
  }
}

function mapDispatchToProps (dispatch) {
  return {
    onSearchTermChange: ({ target: { value } }) => {
      dispatch(lookupString(value))
    }
  }
}

export const municipalitySearch = connect(mapStateToProps, mapDispatchToProps)(
  MunicipalitySearch
)



// WEBPACK FOOTER //
// ./src/components/municipalitySearch/container.js